// extracted by mini-css-extract-plugin
export default {"searchForm":"search_form_searchForm__j8-UT","btns":"search_form_btns__Et+z8","cancelBtn":"search_form_cancelBtn__rpu5d","input":"search_form_input__xW52A"};